<template>
  <div class="big-box">
    <img :src="bgUrl" alt="" class="big-box-img" />
    <div
      class="big-body"
      :style="{ top: `${yAxis * 0.36}px` }"
      v-if="paperworkType == 1"
    >
      <!-- <img :src="tapTopUrl" alt="" class="tap-top" /> -->
      <div class="big-box-title" :style="{ color: ruleForm.titleColor }">
        {{ ruleForm.title }}
      </div>
      <div class="big-box-desc" :style="{ color: ruleForm.descColor }">
        {{ ruleForm.desc }}
      </div>
    </div>
    <div class="tip-all">最多可领取1次</div>
    <div
      v-if="actType == 16 && prizeSettingType == 1 && ladder.prizeShowType == 0"
      class="tip-style"
    >
      <span v-if="ladder.orderCountType == 0" class="order-tip">
        *同时解锁多个奖励时，可任选其中一个奖品，但只能领取1次
      </span>
      <span v-else class="order-tip"> *仅有一次领取机会，多购不重复奖励 </span>
    </div>
    <div class="shop flex-jc">
      <div class="flex-c">
        <img
          class="shop-logo"
          :src="$store.getters.loginUserInfo.picPath"
          alt=""
        />
        <div class="shop-name">
          {{ $store.getters.loginUserInfo.sellerNick }}
        </div>
      </div>
      <div>
        <div
          class="btn-style"
          :style="{ border: `1px solid ${rgb}`, background: `${rgb}` }"
        >
          进店逛逛
        </div>
        <div class="concern" :style="{ border: `1px solid ${rgb}` }">关注</div>
      </div>
    </div>

    <div
      :class="[
        'goods',
        actType == 16 && prizeSettingType == 1 && ladder.prizeShowType == 0
          ? 'goods-sctive'
          : '',
      ]"
      v-if="prizeSetting.length > 2 && (isShowPrize || actType == 17)"
    >
      <div
        :class="[
          'goods-item',
          isShowPrize && ladder.prizeShowType == 0 && prizeSettingType == 1
            ? 'padding-active'
            : '',
        ]"
        v-for="(item,index) in newPrizeSetting"
        :key="index"
      >
        <div
          class="conditions"
          v-if="
            isShowPrize && ladder.prizeShowType == 0 && prizeSettingType == 1
          "
        >
          <span v-if="item.orderAmtLimit > 0 && item.itemTotalLimit > 1"
            >{{ ladder.orderCountType ? "累计" : "单笔" }}满{{
              item.orderAmtLimit
            }}元且商品满{{ item.itemTotalLimit }}件</span
          >
          <span v-else-if="item.orderAmtLimit"
            >{{ ladder.orderCountType ? "累计" : "单笔" }}满{{
              item.orderAmtLimit
            }}元</span
          >
          <span v-else-if="item.itemTotalLimit"
            >{{ ladder.orderCountType ? "累计" : "单笔" }}商品满{{
              item.itemTotalLimit
            }}件</span
          >
        </div>
        <div class="flex-c">
          <img class="img-style" v-if="item.logo" :src="item.logo" alt="" />
          <img
            class="img-style"
            v-else
            :src="prizeLogo(item.prizeType)"
            alt=""
          />
          <div class="prize-style">
            <div class="prize-name">{{ prizeTitle(item) }}</div>
            <div class="prize-num">奖品剩余: {{ prizeNum(item) }}份</div>
          </div>
        </div>
        <div
          class="btn-style"
          :style="{ border: `1px solid ${rgb}`, background: `${rgb}` }"
        >
          解锁
        </div>
      </div>
    </div>
    <div class="goods1" v-else>
      <div class="flex-jc goods1-item" v-for="item in prizeSetting">
        <div
          class="conditions"
          v-if="
            isShowPrize && ladder.prizeShowType == 0 && prizeSettingType == 1
          "
        >
          <span v-if="item.orderAmtLimit > 0 && item.itemTotalLimit > 1"
            >{{ ladder.orderCountType ? "累计" : "单笔" }}满{{
              item.orderAmtLimit
            }}元且商品满{{ item.itemTotalLimit }}件</span
          >
          <span v-else-if="item.orderAmtLimit"
            >{{ ladder.orderCountType ? "累计" : "单笔" }}满{{
              item.orderAmtLimit
            }}元</span
          >
          <span v-else-if="item.itemTotalLimit"
            >{{ ladder.orderCountType ? "累计" : "单笔" }}商品满{{
              item.itemTotalLimit
            }}件</span
          >
        </div>
        <div class="flex-c">
          <img class="img-style" v-if="item.logo" :src="item.logo" alt="" />
          <img
            class="img-style"
            v-else
            :src="prizeLogo(item.prizeType)"
            alt=""
          />
          <div class="prize-style">
            <div class="prize-name">{{ prizeTitle(item) }}</div>
            <div class="prize-num">奖品剩余: {{ prizeNum(item) }}份</div>
          </div>
        </div>
        <div
          class="btn-style"
          :style="{ border: `1px solid ${rgb}`, background: `${rgb}` }"
        >
          解锁
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    bgUrl: {
      type: String,
      default: "",
    },
    yAxis: {
      type: Number,
      default: 0,
    },
    paperworkType: {
      type: Number,
      default: 0,
    },
    rgb: {
      type: String,
      default: "#fff",
    },
    prizeSetting: {
      type: Array,
      default: () => [],
    },
    prizeSettingType: {
      type: Number,
      default: 0,
    },
    actType: {
      type: Number,
      default: 0,
    },
    ladder: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    isShowPrize() {
      return this.actType == 16 || this.actType == 18;
    },
    prizeLogo() {
      return (type) => {
        switch (type) {
          case 1:
            return "http://cdn-image.yucrm.cn/images/orderGift/coupon.png";
          case 2:
            return "http://cdn-image.yucrm.cn/images/orderGift/jd.png";
          case 3:
            return "http://cdn-image.yucrm.cn/images/orderGift/shiwu.svg";
          case 4:
            return "http://cdn-image.yucrm.cn/images/orderGift/jifeng.png";
          case 5:
            return "http://cdn-image.yucrm.cn/images/orderGift/JdE.png";
          case 6:
            return "http://cdn-image.yucrm.cn/images/orderGift/qiy.png";
          case 7:
            return "http://cdn-image.yucrm.cn/images/orderGift/jdplus.png";
          case 8:
            return "http://cdn-image.yucrm.cn/images/orderGift/hongbao.png";
          case 9:
            return "http://cdn-image.yucrm.cn/images/orderGift/shiwu.svg";
        }
      };
    },
    prizeTypes() {
      return (type) => {
        switch (type) {
          case 1:
            return "优惠券";
          case 2:
            return "京豆";
          case 4:
            return "店铺积分";
          case 5:
            return "京豆E卡";
          case 6:
            return "爱奇艺会员";
          case 7:
            return "京东PLUS会员";
          case 8:
            return "红包";
          case 9:
            return "谢谢参与";
          case 10:
            return "礼品卡";
          default:
            return "";
        }
      };
    },
    prizeTitle() {
      return (item) => {
        if (!item.hasOwnProperty("totalAmount")) {
          return item.prizeType == 3 || item.prizeType == 10
            ? item.title
            : (item.prizeType == 5 || item.prizeType == 6 || item.prizeType ==7)  ?  this.prizeTypes(item.prizeType) : (item.price ?  item.price : '') + this.prizeTypes(item.prizeType);
        } else {
          return item.title;
        }
      };
    },
    prizeNum() {
      return (item) => {
        if (!item.hasOwnProperty("totalAmount")) {
          return item.prizeCount;
        } else {
          if(item.prizeCount!=item.totalAmount) {
            return item.prizeCount;
          } else {
            return item.remanentAmount;
          }
        }
      };
    },
    newPrizeSetting() {
      if(this.prizeSetting.length>2) {
        let arr = JSON.parse(JSON.stringify(this.prizeSetting))
        let second = arr.splice(1, 1)[0]; // 移除第二个元素
        let third = arr.splice(1, 1)[0]; // 移除第三个元素（现在是第二个位置）
        arr.splice(1, 0, third, second); // 插入交换后的元素
        return arr
      } else {
        return this.prizeSetting
      }
     
    }
  },
  mounted() {},
  methods: {
    update() {
      this.$forceUpdate();
    }
  },
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  // background: rgba(255, 255, 255, 0.2);
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  .big-box-img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 8px;
    width: 100%;
    height: 100%;
    // height: 580px;
    border-radius: 24px;
  }
  .big-body {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    margin-top: 8px;
    .big-box-title {
      font-size: 16px;
      font-weight: bold;
    }
    .big-box-desc {
      width: 160px;
      margin-top: 14px;
      font-weight: 400;
      font-size: 10px;
      line-height: 12px;
      text-align: center;
    }
    .big-box-goods {
      margin-top: 30px;
      width: 225px;
      height: 48px;
      overflow: hidden;
      display: flex;
      align-items: center;
      .goods-item {
        flex: 0 0 auto; /* 不伸缩，固定宽度 */
        position: relative;
        margin-right: 7px;
        width: 48px;
        height: 48px;
        border-radius: 3px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
        .item-name {
          position: absolute;
          text-align: center;
          width: 48px;
          height: 12px;
          line-height: 12px;
          left: 0;
          bottom: 0;
          font-size: 8px;
          background-color: rgba(0, 0, 0, 0.6);
          color: #ffffff;
          z-index: 9999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          -webkit-line-clamp: 1;
          /*! autoprefixer: off */
          -moz-box-orient: vertical;
          -webkit-box-orient: vertical;
          /*! autoprefixer: on */
        }
      }
    }
    .big-box-middle {
      width: 210px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      margin-top: 20px;
      .box-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        border-radius: 4px;
        .box-item-img {
          width: 42px;
          height: 52px;
        }
      }
      .box-item-img-item,
      .box-item-img-item {
        width: 36px;
        height: 44px;
      }
    }
    .big-box-num {
      margin-top: 18px;
      color: #ffffff;
      font-size: 10px;
    }

    .big-box-footer {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 70px;
      width: 268px;
      height: 99px;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 6px 6px 15px 15px;
      .footer-title {
        margin-top: 12px;
        font-size: 12px;
        color: #ffffff;
      }
      .footer-body {
        width: 100%;
        margin-top: 12px;
        margin-left: 12px;
        font-size: 10px;
        color: #ffffff;
        .footer-body-item {
          display: flex;
          align-items: center;
          .item-left {
            display: flex;
            align-items: center;
            .item-avatar {
              margin-right: 8px;
              width: 24px;
              height: 24px;
              background-color: #ffffff;
              border-radius: 50%;
            }
          }
          .item-right {
            display: flex;
            align-items: center;
            margin-left: 19px;
            .item-action {
              margin-right: 8px;
            }
          }
        }
        .footer-body-item:nth-child(n + 2) {
          margin-top: 7px;
        }
      }
    }

    .more-activity {
      width: 60px;
      height: 60px;
      position: absolute;
      bottom: 125px;
      right: 6px;
    }
  }
  .shop {
    position: absolute;
    top: 193px;
    width: 244px;
    height: 54px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    padding: 6px 7px;
    &-logo {
      width: 30px;
      height: 31px;
      border-radius: 2px 2px 2px 2px;
    }
    &-name {
      font-weight: 400;
      font-size: 10px;
      color: #000000;
      line-height: 12px;
      margin-left: 6px;
    }
    .concern {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 4px;
      width: 57px;
      height: 19px;
      border-radius: 50px;
      font-size: 10px;
      color: #b40001;
    }
  }
  .tip-all {
    position: absolute;
    top: 310px;
    z-index: 2;
    color: #ffffff;
    font-size: 10px;
    text-align: center;
    box-sizing: border-box;
  }
  .tip-style {
    position: absolute;
    top: 318px;
    .order-tip {
      line-height: 0;
      text-align: center;
      font-size: 8px;
      color: #ff0000;
    }
  }
  .goods {
    position: absolute;
    top: 325px;
    width: 244px;
    height: 153px;
    display: flex;
    flex-wrap: wrap;
    margin-right: -8px;
    &-item {
      position: relative;
      width: calc(50% - 8px);
      height: 73px;
      background: #ffffff;
      border-radius: 6px 6px 6px 6px;
      margin-right: 8px;
      margin-bottom: 7px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 10px 7px;
      .img-style {
        width: 27px;
        height: 27px;
        border-radius: 50%;
      }
      .prize-style {
        margin-left: 7px;
        .prize-name {
          font-weight: 400;
          font-size: 10px;
          color: #b40001;
          line-height: 10px;
        }
        .prize-num {
          margin-top: 6px;
          font-weight: 400;
          font-size: 8px;
          color: #333333;
          line-height: 8px;
        }
      }
    }
  }
  .goods-sctive {
    top: 335px;
  }
  .padding-active {
    height: 70px;
    padding: 20px 7px 2px;
  }
  .img-style {
    width: 27px;
    height: 27px;
    border-radius: 50%;
  }
  .prize-style {
    margin-left: 7px;
    .prize-name {
      font-weight: 400;
      font-size: 10px;
      color: #b40001;
      line-height: 10px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* 限制显示3行 */
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .prize-num {
      margin-top: 6px;
      font-weight: 400;
      font-size: 8px;
      color: #333333;
      line-height: 8px;
    }
  }
  .goods1 {
    position: absolute;
    top: 325px;
    width: 244px;
    height: 153px;
    &-item {
      margin-bottom: 8px;
      position: relative;
      padding: 10px 7px;
      height: 73px;
      background: #ffffff;
      border-radius: 6px 6px 6px 6px;
    }
  }
  .conditions {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    text-align: center;
    padding: 4px 0;
    font-size: 10px;
    box-sizing: border-box;
    border-radius: 6px 6px 0 0;
  }
}
.btn-style {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 57px;
  height: 19px;
  font-size: 10px;
  border-radius: 50px;
  color: #ffffff;
}
.flex-jc {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-c {
  display: flex;
  align-items: center;
}
</style>
